import { client } from '../../utils/client.utils';

export const USER_API_ENDPOINTS = {
  login: (user) => client.post('/users/login', user)
};
